import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import inventoryPrivilegeCpcModel from '@/models/inventory/inventory-privilege-cpc'
import router from '@/router'
import store from '@/store'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import {
  onBeforeMount, reactive, ref, watch,
} from '@vue/composition-api'

export default function useInventoryImportDetail() {
  // const STATUS_DUPLICATE = 3;
  const STATUS_SUCCESS = 9
  const STATUS_ERROR = 11

  const { inventoryExternalCodeImportDetail } = inventoryPrivilegeCpcModel()

  const { pagination, onPageChange, onFilterEntity } = usePagination()

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal()

  const loading = reactive({
    tableData: false,
  })

  const importRef = ref('')

  const formStatus = reactive({
    validFrom: null,
    validThrough: null,
    status: null,
  })

  const statusOption = ref([
    { label: 'Success', value: STATUS_SUCCESS },
    { label: 'Error', value: STATUS_ERROR },
    // { label: "Duplicate", value: STATUS_DUPLICATE },
  ])

  const fields = [
    { key: 'seq', label: 'No.' },
    { key: 'serial', label: 'Serial Code' },
    { key: 'exp_time', label: 'Expire Date' },
    { key: 'status', label: 'Status' },
  ]

  const importTable = reactive({
    payload: [],
  })

  const resolveImportStatusLabel = status => {
    switch (status) {
      case STATUS_SUCCESS:
        return 'Success'
      case STATUS_ERROR:
        return 'Error'
      // case STATUS_DUPLICATE:
      //   return "Duplicate";
      default:
        return 'None'
    }
  }

  const resolveImportStatusClass = status => {
    switch (status) {
      case STATUS_SUCCESS:
        return 'success'
      case STATUS_ERROR:
        return 'error'
      // case STATUS_DUPLICATE:
      //   return "duplicate";
      default:
        return 'None'
    }
  }

  const fetchImportList = () => {
    loading.tableData = true
    inventoryExternalCodeImportDetail.payload.Inventory_Id = router.currentRoute.params.invRef
    inventoryExternalCodeImportDetail.payload.Privilege_Id = router.currentRoute.params.ref
    inventoryExternalCodeImportDetail.payload.Import_Id = router.currentRoute.params.importRef
    inventoryExternalCodeImportDetail.payload.Page = pagination.currentPage
    inventoryExternalCodeImportDetail.payload.Limit = pagination.perPage
    inventoryExternalCodeImportDetail.payload.Filters = filters
    inventoryExternalCodeImportDetail.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', inventoryExternalCodeImportDetail)
      .then(response => {
        importTable.payload = response.data.payload
        pagination.rows = response.data.payload.length
        pagination.totalRows = response.data.filtered_record
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
    // if (router.currentRoute.params.importRef) {
    //   importRef.value = router.currentRoute.params.importRef;
    // }
    // importTable.payload = historyImportDetail;
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchImportList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchImportList()
    },
    { deep: true },
  )

  onBeforeMount(() => {
    fetchImportList()
  })

  return {
    importRef,
    formStatus,
    fields,
    loading,
    importTable,
    statusOption,
    resolveImportStatusLabel,
    resolveImportStatusClass,
    pagination,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
  }
}
